import "./style.css";

const InputRadio = ({
    radioItem = [],
    suffixClass = "tw:!mb-3",
    mbLabel = "tw:!mb-1",
    suffixClassLabel,
    label = null,
    infoLabel = null,
    key = ""
}) => {
    return (
        <>
            <div className={suffixClass} key={key}>
                {label && (
                    <label className={`${mbLabel || ""} ${suffixClassLabel || ""}`}>
                        {label} &nbsp;
                        {infoLabel && (
                            <p className="info-label">{infoLabel}</p>
                        )}
                    </label>
                )}

                <div className="tw:!flex tw:!justify-start tw:!items-center tw:!gap-2">
                    {radioItem.map((val) => (
                        <div
                            key={val.name}
                            className={`input-radio-box${val.value ? "-check" : ""} tw:!flex tw:!justify-start tw:!items-center tw:!gap-2 pointer tw:!w-full`}
                            onClick={val.changeValue}
                        >
                            <input
                                className="radio-check-input"
                                type="radio"
                                name={val.name}
                                id={val.name}
                                onChange={val.changeValue}
                                checked={val.value}
                            />
                            <p className="account-text-value tw:!mb-0 tw:!pe-3">
                                {val.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default InputRadio;
